import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import useBreakpoints from '#client/hooks/useBreakpoints';

export default function TransactionItemLoadingSkeleton() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      py="15px"
    >
      <Stack
        alignItems="center"
        direction="row"
        spacing="16px"
      >
        <Skeleton
          height={40}
          variant="rounded"
          width={40}
        />
        <Stack
          alignItems={isDesktop ? 'center' : 'flex-start'}
          direction={isDesktop ? 'row' : 'column'}
          spacing={isDesktop ? '16px' : '2px'}
        >
          <Skeleton
            height={isDesktop ? 24 : 16}
            width={isDesktop ? 90 : 110}
          />
          <Skeleton
            height={isDesktop ? 24 : 16}
            width={isDesktop ? 140 : 80}
          />
        </Stack>
      </Stack>
      <Skeleton
        height={isDesktop ? 24 : 16}
        width={isDesktop ? 140 : 99}
      />
    </Stack>
  );
}
